import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { DemandDTORuntype } from '../negotiation';
import {
    DemandCreationRequestRuntype,
    DemandsExportRequestBodyRuntype,
    DemandsExportResponseRuntype,
    MonitoringDemandsExportRequestBodyRuntype,
    MonitoringDemandsExportResponseRuntype,
    MultiStatusRuntype,
} from './demandBackendTypes';
import { DemandSummaryDemandsRequestRuntype, DemandSummaryResponseRuntype } from './demandSummaryBackendTypes';

export const demandEndpoints = {
    'GET /demand': endpoint({
        description: 'Retrieves all demands',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(DemandDTORuntype),
    }),

    'POST /demand/delete-bulk': endpoint({
        description: 'Deletes multiple demands',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            ids: z.array(z.string()),
        }),
        responseBody: z.unknown(),
        invalidates: ['GET /demand'],
    }),

    'POST /demand/import': endpoint({
        description: 'Posts demands',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DemandCreationRequestRuntype,
        responseBody: z.array(MultiStatusRuntype),
    }),
    'POST /demand/export': endpoint({
        description: 'Fetches demands',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DemandsExportRequestBodyRuntype,
        responseBody: DemandsExportResponseRuntype,
    }),
    'POST /demand/export-monitoring': endpoint({
        description: 'Fetches demands for monitoring time windows',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: MonitoringDemandsExportRequestBodyRuntype,
        responseBody: MonitoringDemandsExportResponseRuntype,
    }),
    'POST /demand/export-summary-demands': endpoint({
        description: 'Fetches demands along with a demand summary',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DemandSummaryDemandsRequestRuntype,
        responseBody: DemandSummaryResponseRuntype,
    }),
    'POST /demand/export-csv': endpoint({
        description: 'Fetches as a CSV',
        pathParams: z.undefined(),
        queryParams: z.object({
            target_date: z.string(),
        }),
        requestBody: DemandsExportRequestBodyRuntype,
        //csv string
        responseBody: z.string(),
    }),
};
